import { useEffect, useState } from 'react';

const useFacebookSDK = () => {
  const [sdkLoaded, setSdkLoaded] = useState(!!window.FB);
  const [sdkError, setSdkError] = useState();

  useEffect(() => {
    if (window.FB) {
      setSdkLoaded(true);
      return;
    }

    const checkSDK = setInterval(() => {
      if (window.FB) {
        setSdkLoaded(true);
        clearInterval(checkSDK);
      }
    }, 100);

    const timeout = setTimeout(() => {
      clearInterval(checkSDK);
      if (!window.FB) {
        setSdkError('Facebook SDK failed to load. Please refresh the page.');
      }
    }, 10000);

    return () => {
      clearInterval(checkSDK);
      clearTimeout(timeout);
    };
  }, []);

  return { sdkLoaded, sdkError };
};

export default useFacebookSDK;
